/**
 * Turns first letter of a string to uppercase, capitalizing the string
 * @function
 *
 * @param   {string} str word to capitalized
 *
 * @returns {string} capitalized word
 */
export const toCapitalized = (str: string): string => {
    const capitalized = str.split(" ");
    return capitalized.map((splitted) => splitted[0].toUpperCase() + splitted.substring(1))
    .join(" ");
}
